import React, { useRef, useContext } from 'react';
import { GlobalContext } from '@/app/providers/globalState';
import { TagFeedback, TooltipTrigger, Text } from '@spark';
import './TrainingStatus.css';
import { getStatusLabel } from '@/features/trainings/utils/trainingUtils';

const STATUS_TO_VARIANT = {
    completed: 'success',
    waiting: 'default',
    preparing: 'processing',
    running: 'processing',
    training: 'processing',
    paused: 'default',
    failed: 'error',
    optimizing: 'processing',
    initializing: 'processing',
    evaluating: 'processing',
    llm_as_a_judge: 'processing',
};

const get_status_tag = (status, errorDetails = null) => {
    const variant = STATUS_TO_VARIANT[status] || 'default';
    const pulseEffect = status === 'failed';

    const statusTag = (
        <TagFeedback
            label={getStatusLabel(status)}
            variant={variant}
            showIcon={status === 'failed'}
            className={pulseEffect ? 'pulse-error' : ''}
        />
    );

    if (status === 'failed' && errorDetails) {
        return (
            <div style={{ display: 'flex', flexDirection: 'row', flex: 1 }}>
                <TooltipTrigger
                    text={`Error Details: ${errorDetails}`}
                    placement="top"
                >
                    <span>{statusTag}</span>
                </TooltipTrigger>
            </div>
        );
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
            {statusTag}
        </div>
    );
};


const TrainingStatus = ({ distillationEventId, initialStatus, initialErrorDetails }) => {
    const { trainStatuses } = useContext(GlobalContext);
    const status = trainStatuses[distillationEventId]?.status || initialStatus;
    const errorDetails = trainStatuses[distillationEventId]?.error_details || initialErrorDetails;

    const statusRef = useRef(null);

    const statusTag = get_status_tag(status, errorDetails);

    return (
        <div ref={statusRef}>
            {statusTag}
        </div>
    );
};

export default TrainingStatus;
